import { capitalize } from "lodash-es";

import { Pill } from "src/design-system/Pill";
import { useIsFeatureFlagEnabled } from "src/hooks/useIsFeatureFlagEnabled";

export const OmniboxFeatureFlagLabel: React.FC<{
  featureFlag: string;
}> = ({ featureFlag }) => {
  const isEnabled = useIsFeatureFlagEnabled(featureFlag);
  return (
    <div className="flex items-center gap-x-2">
      {capitalize(featureFlag).replace("-", " ")}
      {isEnabled && (
        <Pill>
          <Pill.Text>enabled</Pill.Text>
        </Pill>
      )}
    </div>
  );
};
